import React from "react";
import Helmet from "react-helmet";

import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import '../scss/main.scss';

import AssetModel from "../models/asset-model";

var mapInjectionData = {
    title: null,
    position: null,
    markerImage: null
};

function initMap() {

  var customStyles = [
    {
        "stylers": [
            {
                "saturation": -100
            },
            {
                "gamma": 1
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.place_of_worship",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.place_of_worship",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "water",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "saturation": 50
            },
            {
                "gamma": 0
            },
            {
                "hue": "#50a5d1"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#333333"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text",
        "stylers": [
            {
                "weight": 0.5
            },
            {
                "color": "#333333"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "labels.icon",
        "stylers": [
            {
                "gamma": 1
            },
            {
                "saturation": 50
            }
        ]
    }
];

  var map = new google.maps.Map(document.getElementById('map'), {
    zoom: 17,
    center: mapInjectionData.position,
    styles: customStyles
  });

  var marker = new google.maps.Marker({
    position: mapInjectionData.position,
    map: map,
    title: mapInjectionData.title,
    icon: mapInjectionData.markerImage      
  });
}




class IndexLayout extends React.Component {
  constructor(props) {
    super(props);

    this.assetPaths = AssetModel.getPathMap(this.props.data.assets);

    mapInjectionData.markerImage = this.assetPaths[this.props.data.map.imageRelativePath];
    mapInjectionData.title = this.props.data.branding.title;
    mapInjectionData.position = this.props.data.map.position;
  }

  render() {
    const data = this.props.data;
    const children = this.props.children;

    return (
      <div>
        <Helmet>
            <meta charset="utf-8" />
            <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBmsuNX8UoDB80UqkUHs5p8HNiWSSEZt-w&callback=initMap"></script>
            <link href="https://fonts.googleapis.com/css?family=Orbitron" rel="stylesheet" type="text/css" />
            <link href="https://fonts.googleapis.com/css?family=Montserrat:400,700" rel="stylesheet" type="text/css"/>
            <link href='https://fonts.googleapis.com/css?family=Kaushan+Script' rel='stylesheet' type='text/css'/>
            <link href='https://fonts.googleapis.com/css?family=Droid+Serif:400,700,400italic,700italic' rel='stylesheet' type='text/css'/>
            <link href='https://fonts.googleapis.com/css?family=Roboto+Slab:400,100,300,700' rel='stylesheet' type='text/css'/>
            
            <title>{data.branding.title}</title>
            <meta name="description" content={data.branding.siteDescription} />


            <link rel="apple-touch-icon" sizes="57x57" href={this.assetPaths['favicons/apple-icon-57x57.png']} />
            <link rel="apple-touch-icon" sizes="60x60" href={this.assetPaths['favicons/apple-icon-60x60.png']} />
            <link rel="apple-touch-icon" sizes="72x72" href={this.assetPaths['favicons/apple-icon-72x72.png']} />
            <link rel="apple-touch-icon" sizes="76x76" href={this.assetPaths['favicons/apple-icon-76x76.png']} />
            <link rel="apple-touch-icon" sizes="114x114" href={this.assetPaths['favicons/apple-icon-114x114.png']} />
            <link rel="apple-touch-icon" sizes="120x120" href={this.assetPaths['favicons/apple-icon-120x120.png']} />
            <link rel="apple-touch-icon" sizes="144x144" href={this.assetPaths['favicons/apple-icon-144x144.png']} />
            <link rel="apple-touch-icon" sizes="152x152" href={this.assetPaths['favicons/apple-icon-152x152.png']} />
            <link rel="apple-touch-icon" sizes="180x180" href={this.assetPaths['favicons/apple-icon-180x180.png']} />
            <link rel="icon" type="image/png" sizes="192x192" href={this.assetPaths['favicons/android-icon-192x192.png']} />
            <link rel="icon" type="image/png" sizes="32x32" href={this.assetPaths['favicons/favicon-32x32.png']} />
            <link rel="icon" type="image/png" sizes="96x96" href={this.assetPaths['favicons/favicon-96x96.png']} />
            <link rel="icon" type="image/png" sizes="16x16" href={this.assetPaths['favicons/favicon-16x16.png']} />
            <link rel="manifest" href={this.assetPaths['favicons/manifest.json']} />
            <meta name="msapplication-TileColor" content="#ffffff"/>
            <meta name="msapplication-TileImage" content={this.assetPaths['favicons/ms-icon-144x144.png']} />
            <meta name="theme-color" content="#ffffff"/>
        </Helmet>
    
        <div>
        {children()}
        </div>
      </div>
    );
  }

  componentDidMount() {
      window.initMap = initMap;
  }
}

export default IndexLayout;


export const query = graphql`
  query LayoutQuery {
    assets: allFile(filter: { extension: { regex: "/^(jpeg|jpg|png|json)$/" } }) {
        edges {
          node {
            publicURL,
            relativePath,
            name
          }
        }
    },

      map: mapJson {
        position {
            lat,
            lng
        },
        imageRelativePath
    },

    branding: brandingJson {
        siteDescription,
        title,
        logoImageRelativePath
    }

  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js